import { useOrientation } from "@/common/hooks/useOrientation";
import { useTrackVisit } from "@/common/hooks/useTrackVisit";
import { useGetUserData } from "@/common/hooks/useGetUserData";

import { useCheckPreferences } from "./hooks/useCheckPreferences";
import { useCheckExternalMessages } from "./hooks/useCheckExternalMessages";
import { useWindowHistoryByMouse } from "./hooks/useWindowHistoryByMouse";
import { useHideAllMenus } from "./hooks/useHideAllMenus";
import { useGeoBlockedPage } from "./hooks/useGeoBlockedPage";
import { useTrackPWA } from "./hooks/useTrackPWA";
import { useResetSearchTag } from "./hooks/useResetSearchTag";
import { useHeaderScroll } from "./hooks/useHeaderScroll";
import { useDetectGeolocation } from "./hooks/useDetectGeolocation";
import { useTrackCookieConsent } from "./hooks/useTrackCookieConsent";
import { useAgeVerificationStatusPopup } from "./hooks/useAgeVerificationStatusPopup";
import { useGoCtrl } from "./hooks/useGoCtrl";
import { useAppStyles } from "./hooks/useAppStyles";
import { useInitDocumentTitle } from "./hooks/useInitDocumentTitle";
import { useFullScreen } from "./hooks/useFullScreen";
import { useTrackUser } from "./hooks/useTrackUser";
import { useScroll } from "./hooks/useScroll";
import { useTrackFeedVisits } from "./hooks/useTrackFeedVisits";
import { useGTM } from "./hooks/useGTM";
import { useCensor } from "./hooks/useCensor";
import { useFeedModules } from "./hooks/useFeedModules";
import { useAgeDisclaimer } from "./hooks/useAgeDisclaimer";
import { useAgeVerification } from "./hooks/useAgeVerification";
import { useAgeVerificationPromtPopup } from "./hooks/useAgeVerificationPromtPopup";
import { useLiteOnlyVerificationPopup } from "./hooks/useLiteOnlyVerificationPopup";
import { useTrackFeedNavigation } from "./hooks/useTrackFeedNavigation";
import { useTrackNewTabOpen } from "./hooks/useTrackNewTabOpen";

export const AppHooks = () => {
  useGetUserData();
  useCheckPreferences();
  useCheckExternalMessages();
  useDetectGeolocation();
  useAgeVerification();
  useGeoBlockedPage();
  useAgeDisclaimer();

  useTrackVisit();
  useTrackNewTabOpen();
  useAppStyles();
  useWindowHistoryByMouse();
  useInitDocumentTitle();
  useHideAllMenus();
  useFullScreen();
  useTrackUser();
  useOrientation();
  useTrackPWA();
  useResetSearchTag();

  useHeaderScroll();
  useScroll();
  useTrackFeedVisits();

  useTrackCookieConsent();
  useGoCtrl();
  useGTM();

  useCensor();
  useAgeVerificationStatusPopup();
  useAgeVerificationPromtPopup();
  useLiteOnlyVerificationPopup();

  useFeedModules();

  useTrackFeedNavigation();

  return null;
};
